module.exports = __webpack_public_path__ + "static/media/YB5F02_0.89183b68.jpg";